import { originType } from '@atlassiansox/analytics-web-client/analytics-web-types';
import AnalyticsClient from '@atlassiansox/analytics-web-client/client';
import { getEnvType, isLocal } from '@dev-agents/env';

const getApiHost = () => {
	const host = process.env.REMOTE_DOMAIN ? new URL(process.env.REMOTE_DOMAIN).host : '';
	return `${host}/gateway/api/gasv3/api/v1/`;
};

export const devAnalyticsClient = new AnalyticsClient(
	{
		env: getEnvType(),
		locale: 'en',
		product: 'devAgents',
		version: '1.0.0',
		origin: originType.WEB,
	},
	isLocal()
		? {
				apiHost: getApiHost(),
				disableCookiePersistence: true,
			}
		: {
				disableCookiePersistence: true,
			},
);

/**
 * Dedicated analytics client for AI Unified Instrumentation events
 * (`aiInteraction`, `aiResult`, `aiFeedback`). Posts under `product: 'devAi'`
 * so events match the AI MAU pipeline registration. Tenant + user identity
 * is mirrored onto this client by `AnalyticsWebClientProvider`.
 */
export const devAIAnalyticsClient = new AnalyticsClient(
	{
		env: getEnvType(),
		locale: 'en',
		product: 'devAi',
		version: '1.0.0',
		origin: originType.WEB,
	},
	isLocal()
		? {
				apiHost: getApiHost(),
				disableCookiePersistence: true,
			}
		: {
				disableCookiePersistence: true,
			},
);
